import {
  FETCH_SANDOS4U,
  LOY3_CLEAR_TRANSACTIONS,
  LOY3_GET_TRANSACTIONS_SUCCESS,
  REGISTER_SANDOS4U
} from '../constants';
import { userConstants } from "../constants/user.constants";


const loy3MI = localStorage.getItem('_loy3MembershipInfo');
const loy3MembershipInfo = (loy3MI && loy3MI !== 'undefined') && JSON.parse(loy3MI);

const loy3User_ls = localStorage.getItem('_loy3User');
const loy3User = (loy3User_ls && loy3User_ls !== 'undefined') && JSON.parse(loy3User_ls);

const initialState = (loy3MembershipInfo) ? {
  membershipUser: loy3MembershipInfo,
  user: loy3User,
} : {};

export const sandos4U = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_SANDOS4U:
      return {
        ...state,
        sandos4U: action.payload.responseObj
      };
    case REGISTER_SANDOS4U:
      return {
        ...state,
        membershipUser: action.payload.responseObj
      };
    case LOY3_GET_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        transactions: action.transactions,
      };
    case LOY3_CLEAR_TRANSACTIONS:
      return {
        ...state,
        transactions: null, // cannot be an empty array or it won't be reloaded
      };
    case userConstants.LOY3_LOAD_CART_SUCCESS:
      return {
        ...state,
        cart: action.payload
      };
    case userConstants.LOY3_LOAD_CART_FAILURE:
      return {
        ...state,
      };
    case  userConstants.LOGOUT:
      return initialState;
    default:
      return state
  }
};
